import { isValidElement } from "react";

import type { ReactNode } from "react";

export function isDefinedNonZero(value: string | null): number | null {
  return (
    (value && Number.parseInt(value) > 0 && Number.parseInt(value)) || null
  );
}

/**
 * Extend for types. Works somewhat like interface extends (mostly for unions)
 */
export type IExtends<T, TU extends T> = TU;

export function isReactNode(action: unknown): action is ReactNode {
  return (
    isValidElement(action) ||
    typeof action === "string" ||
    typeof action === "number" ||
    typeof action === "boolean" ||
    action === null ||
    action === undefined
  );
}

export function isPromise<T>(obj: unknown): obj is Promise<T> {
  return obj instanceof Promise;
}
